import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Text } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { getSectionSpacing } from '../../sections/Section/Section.js';
import { Link } from '../Link/Link.js';

/**
 * The styled component for the NavigationColumns
 */
var StyledNavigationColumns = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isVisible = _a.isVisible;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    opacity: ", ";\n    pointer-events: ", ";\n    width: 100%;\n    transition: 0.2s cubic-bezier(0.7, 0.04, 0.4, 1);\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    opacity: ", ";\n    pointer-events: ", ";\n    width: 100%;\n    transition: 0.2s cubic-bezier(0.7, 0.04, 0.4, 1);\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n  "])), isVisible ? '1' : '0', isVisible ? 'auto' : 'none', theme.designTokens.colors.grey10, theme.designTokens.colors.grey30);
});
/**
 * The styled component for the Columns
 */
var Columns = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isVisible = _a.isVisible;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    list-style: none;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%;\n    gap: ", ";\n\n    ", "\n  "], ["\n    list-style: none;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%;\n    gap: ", ";\n\n    ", "\n  "])), theme.spacing[8], isVisible && getSectionSpacing({
    theme: theme,
    xPadding: [6, 8, 12, 24],
    yPadding: 6
  }));
});
/**
 * The styled component for the Column
 */
var Column = styled.ul(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1;\n  padding: 0;\n  list-style: none;\n  display: ", ";\n  flex-direction: column;\n"], ["\n  flex: 1;\n  padding: 0;\n  list-style: none;\n  display: ", ";\n  flex-direction: column;\n"])), function (_a) {
  var isVisible = _a.isVisible;
  return isVisible ? 'flex' : 'none';
});
/**
 * The styled component for the ColumnItem
 */
var ColumnItem = styled.li(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: 0;\n    padding-bottom: ", ";\n\n    a {\n      display: block;\n      width: 100%;\n    }\n  "], ["\n    padding: 0;\n    padding-bottom: ", ";\n\n    a {\n      display: block;\n      width: 100%;\n    }\n  "])), theme.spacing[3]);
});
/**
 * The NavigationColumns component
 */
var NavigationColumns = function (_a) {
  var main = _a.main,
    shouldShowColumns = _a.shouldShowColumns,
    openMenuIndex = _a.openMenuIndex;
  return main ? jsx(StyledNavigationColumns, {
    isVisible: shouldShowColumns,
    children: jsx(Columns, {
      isVisible: shouldShowColumns,
      children: main.map(function (menu, menuIndex) {
        var _a;
        return (_a = menu.children) === null || _a === void 0 ? void 0 : _a.map(function (column, columnIndex) {
          return jsxs(Column, {
            isVisible: menuIndex === openMenuIndex,
            children: [jsx(Text, {
              as: "li",
              type: "labelLargeBold",
              spaceAfter: 4,
              children: column.title
            }), column.children.map(function (_a, linkIndex) {
              var to = _a.to,
                title = _a.title;
              return jsx(ColumnItem, {
                children: jsx(Link, {
                  to: to,
                  children: title
                })
              }, "link-".concat(linkIndex));
            })]
          }, "columns-".concat(columnIndex));
        });
      })
    })
  }) : null;
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

export { NavigationColumns };
//# sourceMappingURL=NavigationColumns.js.map
